import React from "react";
import EmotionGraph from "../../components/analitems/EmotionGraph";
import TopSection from "../../components/analitems/TopSection";

const AnalIndex = () => {
  return (
    <div className="w-full h-full overflow-scroll py-5 px-2">
      <div>
        <TopSection />
        <div className="mt-6 flex">
          <EmotionGraph />
        </div>
      </div>
    </div>
  );
};

export default AnalIndex;
